import { SWRConfiguration } from 'swr';

import { useArraySWR } from '~/hooks/useSWR';

import { getPendingData } from './data';

export const useSchedulePendingEmployment = (
  employeeId: number,
  swrConfig?: SWRConfiguration,
) => {
  return useArraySWR(
    ['schedulePendingEmployment', employeeId],
    () => getPendingData(employeeId),
    { revalidateOnFocus: false, ...swrConfig },
  );
};
